// GoogleHotels.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Bus401 = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.tib.org/documents/20124/420692/L401%2C+des+de+2025.04.01.pdf/147cabc6-ccad-c4dc-d756-376fd7591dce?version=2.0&t=1743503256911",
  };

  return (
    <>
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="bi bi-bus-front icon-space" />
        401
      </button>
      {showModal && (
        <LanguageModal
          title="Bus 401"
          icon="bi bi-bus-front"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Bus401;
